import React from "react";

const FireDisplacedCheckbox = ({ isChecked, handleFormValues }) => {
  return (
    <div className="wantad-type-wrap pb-0">
      <div className="row">
        <label className={"check-wrap mb-3"}>
          <input
            type="checkbox"
            name="fire_checkbox"
            checked={isChecked}
            onChange={(e) => {
              handleFormValues({ fireDisplaced: e.target.checked });
            }}
          />
          <span>
            <div className="wantad-type-info">
              <h2 className={false ? "pb-0 red-marked-subheading" : " pb-0 wanted-info-list"}>
                Displaced By Fire:
              </h2>
            </div>
          </span>
        </label>
      </div>
    </div>
  );
};

export default FireDisplacedCheckbox;
